import React from "react";
import PageWrapper from "./state.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import StateTable from "../../components/state/StateTable";

const State = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.state"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.state"
          }
        ]}
      />
      <div className="user-tbl">
        <StateTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, null)(State);
